// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';

import * as Styles from './Content.styles';
import Statement from './Statement';
import NotificationSection from './NotificationSection';
import DocumentsSection from './DocumentsSection';
import CertificationSection from './CertificationSection';
import LeadershipSection from './LeadershipSection';
import RequestAccessSection from './RequestAccessSection';
import { Flex } from '../../../../../components/Flex';

function Content() {
  return (
    <Styles.ContentContainer data-testid="enterprise-content">
      <Flex
        direction="column"
        gap="36px"
      >
        <Statement />
        <NotificationSection />
        <DocumentsSection />
        <CertificationSection />
        <LeadershipSection />
        <RequestAccessSection />
      </Flex>
    </Styles.ContentContainer>
  );
}

export default Content;
